var _defs, _rect, _path, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n        opacity: .4;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #66748f;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.26,
    y: 82.68,
    width: 76.12,
    height: 28.96,
    rx: 11.2,
    ry: 11.2,
    transform: "translate(35.79 -56.13) rotate(16.26)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.28,24.67c-25.01,4.9-41.31,29.16-36.41,54.17,4.9,25.01,29.16,41.31,54.17,36.41,25.01-4.9,41.31-29.16,36.41-54.17-4.9-25.01-29.16-41.31-54.17-36.41ZM130.23,103.11c-17.85,3.5-35.15-8.13-38.65-25.98-3.5-17.85,8.13-35.15,25.98-38.65,17.85-3.5,35.15,8.13,38.65,25.98,3.5,17.85-8.13,35.15-25.98,38.65Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 167.16,
    y: 79.38,
    width: 14.13,
    height: 12.16,
    transform: "translate(37.1 -51.85) rotate(18.91)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.38,58.48v20.26c0,.62.51,1.13,1.13,1.13h.9c1.17-2.02,3.35-3.38,5.85-3.38s4.69,1.36,5.85,3.38h7.66c.62,0,1.13-.51,1.13-1.13v-20.26c0-.62-.51-1.13-1.13-1.13h-20.26c-.62,0-1.13.51-1.13,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.89,58.48v20.26c0,.62-.51,1.13-1.13,1.13h-7.66c-1.17-2.02-3.35-3.38-5.85-3.38s-4.69,1.36-5.85,3.38h-.9c-.62,0-1.13-.51-1.13-1.13v-20.26c0-.62.51-1.13,1.13-1.13h20.26c.62,0,1.13.51,1.13,1.13ZM130.02,83.25c0,3.73,3.03,6.75,6.75,6.75s6.75-3.03,6.75-6.75h2.75c.89,0,1.66-.68,1.72-1.57.07-.99-.71-1.81-1.68-1.81h-.53v-8.63c0-1.05-.42-2.05-1.15-2.79l-6.56-6.56c-.74-.74-1.74-1.15-2.79-1.15h-3v-2.25c0-2.49-2.02-4.5-4.5-4.5h-20.26c-2.49,0-4.5,2.02-4.5,4.5v20.26c0,2.48,2.02,4.5,4.5,4.5,0,3.73,3.03,6.75,6.75,6.75s6.75-3.03,6.75-6.75h9.01ZM142.21,70.86s.02-.02.03,0h-9.97v-6.75h3.02c.15,0,.3.06.4.16l6.59,6.59h-.07ZM110.85,83.23c0-1.87,1.51-3.38,3.38-3.38s3.38,1.51,3.38,3.38-1.51,3.38-3.38,3.38-3.38-1.51-3.38-3.38ZM136.74,79.85c1.87,0,3.38,1.51,3.38,3.38s-1.51,3.38-3.38,3.38-3.38-1.51-3.38-3.38,1.51-3.38,3.38-3.38Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorSearch);
export default __webpack_public_path__ + "static/media/vendor_search.b8ac5fe26e60987beee10d3c1e09eabc.svg";
export { ForwardRef as ReactComponent };